import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AdminLayout from '@/components/admin/AdminLayout';
import EventForm from '@/components/admin/EventForm';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('admin_token')}`
});

export default function AdminEventCreatePage() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (formData) => {
    try {
      setLoading(true);
      const response = await axios.post(`${API}/admin/events`, formData, {
        headers: getAuthHeaders()
      });

      if (response.data.success) {
        toast.success('Event created successfully');
        navigate('/admin/events');
      }
    } catch (error) {
      console.error('Failed to create event:', error);
      if (error.response?.status === 401) {
        localStorage.removeItem('admin_token');
        navigate('/admin/login');
      } else if (error.response?.status === 400) {
        toast.error(error.response.data.detail || 'Event with this slug already exists');
      } else {
        toast.error('Failed to create event');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center space-x-4">
          <Button
            variant="outline"
            onClick={() => navigate('/admin/events')}
            className="flex items-center"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back
          </Button>
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Create Event</h1>
            <p className="text-gray-600 mt-1">Add a new event to the Events Hub</p>
          </div>
        </div>

        {/* Form */}
        <EventForm
          onSubmit={handleSubmit}
          loading={loading}
          submitLabel="Create Event"
        />
      </div>
    </AdminLayout>
  );
}